import { T } from "@/locales";

export default {
  text: [
    { max: 32, message: T('超出最大长度 (32)'), trigger: 'change' }
  ],
}